export default {"src":"/_next/static/media/free-shipping-truck.79e16b67.svg","height":19,"width":24,"blurWidth":0,"blurHeight":0};